import { useEffect } from "react";

const isBrowser = typeof document !== "undefined";

const cache = new Map();

function warm(url) {
  if (!url) return null;
  const existing = cache.get(url);
  if (existing) return existing;

  const img = new Image();
  img.decoding = "async";
  img.loading = "eager";

  let link = null;
  if (isBrowser) {
    link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = url;
    link.fetchPriority = "high";
    document.head.appendChild(link);
  }

  const entry = { img, link, status: "loading", url };
  cache.set(url, entry);

  img.addEventListener("load", () => {
    entry.status = "loaded";
  });
  img.addEventListener("error", () => {
    entry.status = "error";
  });

  img.src = url;
  return entry;
}

export function prefetchImages(urls) {
  if (!isBrowser || !urls) return;
  const list = Array.isArray(urls) ? urls : [urls];
  list.forEach((u) => warm(u));
}

export function isImageReady(url) {
  return cache.get(url)?.status === "loaded";
}

export default function useImagePrefetch(urls) {
  useEffect(() => {
    prefetchImages(urls);
  }, [urls]);
}
